import { createFileRoute } from '@tanstack/react-router'
import { MeScreen } from '../features/me'
import { meQuery, notificationPrefsQuery } from '../features/me/queries'

export const Route = createFileRoute('/me')({
  loader: ({ context }) =>
    Promise.all([context.queryClient.ensureQueryData(meQuery()), context.queryClient.ensureQueryData(notificationPrefsQuery())]),
  component: MeScreen,
})
